import { ADD_NEW_REVIEW_RESTAURANT } from "../actions/entitiesActions";
import { SET_CHAIN_REVIEWS, SET_CHAIN_REVIEWS_LOADING, SET_FULL_RESTAURANT } from "../actions/restaurantActions";

const defaultState = {
  fullRestaurant: {},
  chainReviews: [],
  isLoadingChainReviews: false,
  chainReviewsLastFetched: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_FULL_RESTAURANT:
      return { ...state, fullRestaurant: action.payload };
    case ADD_NEW_REVIEW_RESTAURANT:
      const newRestaurant = { ...state.fullRestaurant };
      newRestaurant.reviews = [action.payload, ...newRestaurant.reviews];
      return { ...state, fullRestaurant: newRestaurant };
    case SET_CHAIN_REVIEWS:
      return {
        ...state,
        chainReviews: action.payload,
        isLoadingChainReviews: false,
        chainReviewsLastFetched: Date.now(),
      };
    case SET_CHAIN_REVIEWS_LOADING:
      return {
        ...state,
        isLoadingChainReviews: action.payload,
      };
  }
  return state;
};
